class Transform {
  constructor({ response }) {
    this.response = response;
  }

  get productDetail() {
    const item = this.response;
    let Obj = {
      admin_fee: '',
      benefits: '',
      category: {
        code: '',
        description: '',
        name: '',
        type: ''
      },
      contents: '',
      currency_code: '',
      detail: {
        claim: {
          flow: [],
          support: {
            available: '',
            call: '',
            email: '',
            whatsapp: ''
          }
        },
        excerpt: [],
        label: [],
        position: '',
        product: {
          benefits: {},
          coverages: [],
          description: '',
          generalInsuranceName: '',
          name: '',
          periode: '',
          periodeType: '',
          planCode: '',
          spesific: [],
          url: {
            brochure: '',
            claimDeath: '',
            claimForm: '',
            tnc: '',
            hospital: ''
          }
        },
        terms: []
      },
      entity: '',
      free_look_period: '',
      hardcopy_admin_fee: '',
      insurance: {
        alias: '',
        code: '',
        is_active: '',
        logo: '',
        name: ''
      },
      insurance_code: '',
      insurance_detail: '',
      insurer_name: '',
      is_active: '',
      isChecked: '',
      logo: '',
      name: '',
      period: {
        periodEnd: '',
        periodStart: ''
      },
      premium: 0,
      premium_period: '',
      premium_type: '',
      product_category: '',
      product_code: '',
      summary: '',
      terms: ''
    };
    if (item) {
      Obj = {
        admin_fee: item.admin_fee,
        benefits: item.benefits,
        category: {
          code: item.category.code,
          description: item.category.description,
          name: item.category.name,
          type: item.category.type
        },
        contents: item.contents,
        currency_code: item.currency_code,
        detail: {
          claim: {
            flow: item.detail.claim.flow,
            support: {
              available: item.detail.claim.support.available,
              call: item.detail.claim.support.call,
              email: item.detail.claim.support.email,
              whatsapp: item.detail.claim.support.whatsapp
            }
          },
          excerpt: item.detail.excerpt,
          label: item.detail.label,
          position: item.detail.position,
          product: {
            benefits: item.detail.product.benefits,
            coverages: item.detail.product.coverages,
            description: item.detail.product.description,
            generalInsuranceName: item.detail.product.generalInsuranceName,
            name: item.detail.product.name,
            periode: item.detail.product.periode,
            periodeType: item.detail.product.periodeType,
            planCode: item.detail.product.planCode,
            spesific: item.detail.product.spesific,
            url: {
              brochure: item.detail.product.url.brochure,
              claimDeath: item.detail.product.url.claimDeath,
              claimForm: item.detail.product.url.claimForm,
              tnc: item.detail.product.url.tnc,
              hospital: item.detail.product.url.hospital || ''
            }
          },
          terms: item.detail.terms
        },
        entity: item.entity,
        free_look_period: item.free_look_period,
        hardcopy_admin_fee: item.hardcopy_admin_fee,
        insurance: {
          alias: item.insurance.alias,
          code: item.insurance.code,
          is_active: item.insurance.is_active,
          logo: item.insurance.logo,
          name: item.insurance.name
        },
        insurance_code: item.insurance_code,
        insurance_detail: item.insurance_detail,
        insurer_name: item.insurer_name,
        is_active: item.is_active,
        isChecked: item.isChecked,
        logo: item.logo,
        name: item.name,
        period: {
          periodEnd: item.period.periodEnd,
          periodStart: item.period.periodStart
        },
        premium: item.premium,
        premium_period: item.premium_period,
        premium_type: item.premium_type,
        product_category: item.product_category,
        product_code: item.product_code,
        summary: item.summary,
        terms: item.terms
      };
      return Obj;
    }
    return Obj;
  }
}

export const mapResponse = ({ type, response }) => {
  const transformResponse = new Transform({ response });
  return transformResponse[type];
};
